import { useCallback } from 'react'
import { withStyles } from '@aura/components/styles'
import Button from '@aura/components/button'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import LanguageIcon from '@mui/icons-material/Language'
import { isEnglish, isFrench } from '../../constants/app'
import constants from '../../constants/languages'
import { REGISTRATION_ROUTE, FORGOTPWD_ROUTE, SESSION_TIMEOUT, ANALYTICS_REGISTER, LOGIN_ROUTE } from '../../constants/routes'
import styles from './styles'


const Component = ({
    classes,
    clsName,
    component,
    loginTitle,
    showTitle = true,
    validateForm,
    variant
}) => {

    const { t: translate, i18n } = useTranslation()
    const history = useHistory()
    const params = new URLSearchParams(location.search)

    const toggleLanguage = useCallback(async event => {
        let newlang = ''
        let newPath = ''
        if (isEnglish(i18n.language)) {
            newlang = constants.FRENCH
        } else if (isFrench(i18n.language)) {
            newlang = constants.ENGLISH
        }
        if (window.location.pathname.endsWith(`/${constants.ENGLISH}`) || window.location.pathname.endsWith(`/${constants.FRENCH}`)) {
            newPath = window.location.pathname.slice(0, -2) + newlang
        } else {
            if (window.location.pathname.endsWith('/')) {
                newPath = window.location.pathname + newlang
            } else {
                newPath = window.location.pathname + '/' + newlang
            }
        }
        i18n.changeLanguage(newlang)
        document.title = translate(loginTitle)
        if (component !== LOGIN_ROUTE) {
            if (!newPath.startsWith(FORGOTPWD_ROUTE) && !newPath.startsWith(REGISTRATION_ROUTE)) {
                if (newPath.startsWith(SESSION_TIMEOUT) || newPath.startsWith('/message') || newPath.startsWith('/error')) {
                    history.goForward()
                } else {
                    history.push(newPath)
                }
            } else if (newPath.startsWith(FORGOTPWD_ROUTE) || newPath.startsWith(REGISTRATION_ROUTE) || newPath.startsWith(ANALYTICS_REGISTER)) {
                params.set('language', newlang)
                const newSearch = params.toString()
                history.replace(`${location.pathname}?${newSearch}`)
            }
        } else {
            validateForm()
            history.push(newPath)
        }
    })

    return (
        <Button 
            variant={variant} 
            className={`${classes[clsName]} ${!showTitle && classes.hideTitle} ${classes.alignment}`} 
            onClick={toggleLanguage}
            disableRipple
        >
            <LanguageIcon className='icon iconLeft' />{showTitle && (isFrench(i18n.language) ? 'English' : 'Francais')}
        </Button>
    )
}
Component.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(Component, styles)
